import { TextInputProps } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { DictionaryTreeFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';
import UniqueId from '../../../services/uid/UniqueId';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';
import LookupBoxTreeContainer from './FormLookupBoxTreeContainer';
import FormTextControl from './hoc/FormTextControl';
import { RequiredHistoryProps, withHistory } from './hoc/HistoryContainer';

interface Props
  extends
    RequiredHistoryProps,
    TFormControlConnectorProps,
    Pick<TextInputProps, 'className' | 'keymap' | 'onValidate'> {
  control: DictionaryTreeFormControlViewModel;
  formId: UniqueId;
  value: string;
}

const TreeNodeInputControl: React.FC<Props> = ({
  areHintsShown,
  className,
  control,
  formId,
  keymap,
  onRef,
  rounded,
  value,
  onRunSingleUpdater,
  onChange,
  onChanged,
  onValidate,
}) => (
  <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
    <LookupBoxTreeContainer
      allowTextOverflow
      canClearOnReadOnly={control.canClearOnReadOnly}
      className={className}
      disabled={control.disabled}
      formId={formId}
      invalid={control.invalid}
      keymap={keymap}
      lengthInBytes={control.lengthInBytes}
      maxLength={control.maxLength}
      name={control.name}
      onRef={onRef}
      readOnly={control.readonly}
      required={control.required}
      rounded={rounded}
      tree={control.tree}
      value={value || ''}
      onChange={onChange}
      onChanged={onChanged}
      onRunSingleUpdater={control.updater ? onRunSingleUpdater : undefined}
      onValidate={onValidate}
    />
  </FormLabeledInputControl>
);

export default withHistory(FormTextControl(TreeNodeInputControl));
